<!--<img *ngIf="loading" src="../../../assets/images/loader.gif" />-->
<div class="bg-secondary px-2" [ngClass]="{'text-center': isContentCentered}">
    <span class="fs-5 text-white" *ngIf="showButtonAccept" mat-dialog-title><span
            class="vag-bold-font">{{boldTitle}}</span>
        {{titulo}}</span>
</div>
<mat-dialog-content class="m-0 px-4 text-center" *ngIf="form || message || isPdfDocument">
    <div *ngIf="!form && message" class="mensaje-texto" [innerHTML]="message">
    </div>
    <div *ngIf="form && formGroup && !message">
        <form class="form-group" [formGroup]="formGroup">
            <div class="container">
                <div class="d-block d-md-flex flex-wrap">
                    <div class="col my-2" *ngFor="let item of form" [ngClass]="{'col-lg-4': form.length > 1}">
                        <label for="{{item.name}}" *ngIf="item.element !== 'checkbox' && item.element !== 'radio'"
                            class="vag-bold-font" [ngClass]="item.labelClass">{{item.label}}</label><br />
                        <input
                            *ngIf="item.element === 'text' || item.element === 'number' || item.element === 'password' || item.element === 'email'"
                            name="{{item.name}}" formControlName="{{item.name}}" type="{{item.element}}" />
                        <select *ngIf="item.element === 'select'" formControlName="{{item.name}}" id="{{item.name}}">
                            <option selected value="">Selección una opción</option>
                            <option *ngFor="let ref of item.options" value="{{ref.value}}">
                                {{ref.key[item.referenceName]}}
                            </option>
                        </select>
                        <div class="input-group" *ngIf="item.element === 'date'">
                            <input class="form-control fs-5" placeholder="yyyy-mm-dd" formControlName="{{item.name}}"
                                name="dp" ngbDatepicker #d="ngbDatepicker" id="{{item.name}}">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()"
                                    type="button"></button>
                            </div>
                        </div>
                        <div class="form-check" *ngIf="item.element === 'checkbox'">
                            <input class="form-check-input" type="checkbox" formControlName="{{item.name}}" value=""
                                id="{{item.name}}" id="{{item.name}}">
                            <label class="form-check-label" for="{{item.name}}" [ngClass]="item.labelClass">
                                {{item.label}}
                            </label>
                        </div>
                        <div class="form-check" *ngIf="item.element === 'radio'">
                            <input class="form-check-input" type="radio" formControlName="{{item.name}}"
                                [checked]="item.value" id="{{item.name}}" name="{{item.name}}" id="{{item.name}}">
                            <label class="form-check-label" for="{{item.name}}" [ngClass]="item.labelClass">
                                Otro
                            </label>
                        </div>
                        <div class="d-flex justify-content-center align-items-center" *ngIf="item.element === 'list'">
                            <div class="form-check p-0 m-0 list">
                                <ul class="p-0 m-0">
                                    <li *ngFor="let li of item.list" [ngClass]="li.elementClass">
                                        <input *ngIf="li.element ==='checkbox'" class="form-check-input" type="checkbox"
                                            value="{{li.value}}" id="{{li.name}}" id="{{li.name}}"
                                            [checked]="li.checked">
                                        <input *ngIf="li.element ==='radio'" class="form-check-input" type="radio"
                                            value="{{li.value}}" id="{{li.name}}" id="{{li.name}}"
                                            [checked]="li.checked">
                                        <label *ngIf="!li.link" class="form-check-label h5 mb-2" for="{{li.name}}"
                                            [ngClass]="li.labelClass">
                                            {{li.label}}
                                        </label>
                                        <a *ngIf="li.link" target="_blank" href="{{li.href}}"
                                            class="ml-1">{{li.label}}</a>
                                        <label for="{{li.name}}"
                                            *ngIf="li.element !== 'checkbox' && li.element !== 'radio'"
                                            class="vag-bold-font" [ngClass]="li.labelClass">{{item.label}}</label><br />

                                        <div *ngIf="li.element === 'number' || li.element === 'text' || li.element === 'number' || li.element === 'password' || li.element === 'email'"
                                            class="input-group mx-auto mt-2 mb-3" [ngClass]="li.containerClass">
                                            <button class="btn btn-outline-darkgray rounded-0"
                                                (click)="addNumber(li.name)"
                                                *ngIf="li.element === 'number' && li.inputClass.indexOf('custom-input-number') >= 0"
                                                type="button" id="button-addon1">+</button>
                                            <input class="form-control" [ngClass]="li.inputClass" name="{{li.name}}"
                                                formControlName="{{li.name}}" type="{{li.element}}" value="{{li.value}}"
                                                placeholder="{{li.placeholder | titlecase}}" [min]="li.min"
                                                [max]="li.max" />
                                            <button class="btn btn-outline-darkgray rounded-0"
                                                (click)="removeNumber(li.name)"
                                                *ngIf="li.element === 'number' && li.inputClass.indexOf('custom-input-number') >= 0">-</button>
                                        </div>

                                        <select *ngIf="li.element === 'select'" formControlName="{{li.name}}"
                                            id="{{li.name}}">
                                            <option selected value="">Selección una opción</option>
                                            <option *ngFor="let ref of li.options" value="{{ref.value}}">
                                                {{ref.key[li.referenceName]}}
                                            </option>
                                        </select>
                                        <div class="captcha">
                                            <app-captcha *ngIf="li.element === 'captcha'" [formGroup]="formGroup"
                                                [element]="li"></app-captcha>
                                        </div>
                                    </li>
                                </ul>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <mat-dialog-content *ngIf="isPdfDocument" [innerHTML]="message" id="pdfDocument">
    </mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions class="m-0">
    <div *ngIf="!form && message" class="flex-column col">
        <div class="d-flex justify-content-center">
            <button *ngIf="showButtonCancel" mat-dialog-close mat-raised-button class="btn btn-secondary"
                tabindex="-1">{{labelButtonCancel}}</button>
            <button *ngIf="showButtonAccept" mat-dialog-close
                class="btn btn-outline-secondary">{{labelButtonSave}}</button>
        </div>
    </div>
    <div *ngIf="(form && !message && (showButtonCancel || showButtonAccept)) || html" class="flex-column col">
        <div class="d-flex justify-content-center" *ngIf="formGroup">
            <button *ngIf="showButtonCancel || html" class="btn btn-secondary col-3 mr-2" (click)="onConfirmClick()"
                tabindex="-1">{{labelButtonCancel}}</button>
            <button *ngIf="showButtonAccept || html" [disabled]="!formGroup.valid"
                class="btn btn-outline-secondary col-3" (click)="guardarForm()">{{labelButtonSave}}</button>
        </div>

        <div class="d-flex justify-content-center" *ngIf="!formGroup">
            <button mat-raised-button class="btn cancelar" (click)="onConfirmClick()" tabindex="-1">Cancelar</button>
            <button *ngIf="showButtonAccept" class="btn guardar" (click)="printDocument()">Guardar</button>
        </div>
        <div *ngIf="showPromotionText" class="mt-3 text-center">*Promoción válida para nuevos alumnos
        </div>
    </div>
</mat-dialog-actions>
<!-- <mat-dialog-content *ngIf="!form && message">
    <div class="mensaje-texto" [innerHTML]="message">
    </div>
</mat-dialog-content> -->
<!-- <mat-dialog-actions align="center" *ngIf="!form && message">
    <button *ngIf="showButtonCancel" mat-dialog-close mat-raised-button class="btn cancelar"
        tabindex="-1">{{labelButtonCancel}}</button>
    <button *ngIf="showButtonAccept" mat-dialog-close class="btn guardar">{{labelButtonSave}}</button>
</mat-dialog-actions> -->

<!-- <mat-dialog-content *ngIf="form && formGroup && !message">
    <form class="form-group" [formGroup]="formGroup">
        <div class="container">
            <div class="row">
                <div class="col-lg" *ngFor="let item of form">
                    <label for="{{item.name}}" *ngIf="item.element !== 'checkbox' && item.element !== 'radio'"
                        class="vag-bold-font">{{item.label}}</label><br />
                    <input
                        *ngIf="item.element === 'text' || item.element === 'number' || item.element === 'password' || item.element === 'email'"
                        name="{{item.name}}" formControlName="{{item.name}}" type="{{item.element}}" />
                    <select *ngIf="item.element === 'select'" formControlName="{{item.name}}" id="{{item.name}}">
                        <option selected value="">Selección una opción</option>
                        <option *ngFor="let ref of item.options" value="{{ref.value}}">{{ref.key[item.referenceName]}}
                        </option>
                    </select>
                    <div class="input-group" *ngIf="item.element === 'date'">
                        <input class="form-control fs-5" placeholder="yyyy-mm-dd" formControlName="{{item.name}}"
                            name="dp" ngbDatepicker #d="ngbDatepicker" id="{{item.name}}">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()"
                                type="button"></button>
                        </div>
                    </div>
                    <div class="form-check" *ngIf="item.element === 'checkbox'">
                        <input class="form-check-input" type="checkbox" formControlName="{{item.name}}" value=""
                            id="{{item.name}}" id="{{item.name}}">
                        <label class="form-check-label" for="{{item.name}}">
                            {{item.label}}
                        </label>
                    </div>
                    <div class="form-check" *ngIf="item.element === 'radio'">
                        <input class="form-check-input" type="radio" formControlName="{{item.name}}"
                            [checked]="item.value" id="{{item.name}}" name="{{item.name}}" id="{{item.name}}">
                        <label class="form-check-label" for="{{item.name}}">
                            Otro
                        </label>
                    </div>
                    <div class="form-check list" *ngIf="item.element === 'list'">
                        <ul>
                            <li *ngFor="let li of item.list">
                                <input *ngIf="li.element ==='checkbox'" class="form-check-input" type="checkbox"
                                    value="{{li.value}}" id="{{li.name}}" id="{{li.name}}" [checked]="li.checked">
                                <input *ngIf="li.element ==='radio'" class="form-check-input" type="radio"
                                    value="{{li.value}}" id="{{li.name}}" id="{{li.name}}" [checked]="li.checked">
                                <label *ngIf="!li.link" class="form-check-label h5 mb-2" for="{{li.name}}">
                                    {{li.label}}
                                </label>
                                <a *ngIf="li.link" target="_blank" href="{{li.href}}" class="ml-1">{{li.label}}</a>
                                <label for="{{li.name}}" *ngIf="li.element !== 'checkbox' && li.element !== 'radio'"
                                    class="vag-bold-font">{{item.label}}</label><br />
                                <input class="form-control mx-auto mt-2 mb-3"
                                    *ngIf="li.element === 'text' || li.element === 'number' || li.element === 'password' || li.element === 'email'"
                                    name="{{li.name}}" formControlName="{{li.name}}" type="{{li.element}}"
                                    placeholder="{{li.placeholder | titlecase}}" />
                                <select *ngIf="li.element === 'select'" formControlName="{{li.name}}" id="{{li.name}}">
                                    <option selected value="">Selección una opción</option>
                                    <option *ngFor="let ref of li.options" value="{{ref.value}}">
                                        {{ref.key[li.referenceName]}}
                                    </option>
                                </select>
                                <div class="captcha">
                                    <app-captcha *ngIf="li.element === 'captcha'" [formGroup]="formGroup"
                                        [element]="li"></app-captcha>
                                </div>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content> -->

<!-- <mat-dialog-actions *ngIf="form && !message && showButtonCancel && showButtonAccept" class="flex-column col">
    <div class="d-flex justify-content-center">
        <button mat-raised-button class="btn cancelar shadow-none p-0 my-0 ml-0 mr-2" (click)="onConfirmClick()"
            tabindex="-1">{{labelButtonCancel}}</button>
        <button [disabled]="!formGroup.valid" class="btn guardar p-0 my-0 ml-0 mr-2"
            (click)="guardarForm()">{{labelButtonSave}}</button>
    </div>
    <div *ngIf="showPromotionText" class="mt-3">*Promoción válida exclusivamente para nuevos alumnos
    </div>
</mat-dialog-actions> -->

<!-- <mat-dialog-actions align="center"
    *ngIf="(form && !message) && (showButtonCancel && !showButtonAccept || !showButtonCancel && showButtonAccept)">
    <div style="width: 100%;">
        <button mat-raised-button *ngIf="showButtonCancel" class="btn cancelar shadow-none" (click)="onConfirmClick()"
            tabindex="-1">{{labelButtonCancel}}</button>
    </div>

    <div style="width: 100%;">
        <button *ngIf="showButtonAccept" [disabled]="!formGroup.valid" class="btn guardar"
            (click)="guardarForm()">{{labelButtonSave}}</button>
    </div>
    <div *ngIf="showPromotionText">*Promoción válida exclusivamente para nuevos alumnos</div>
</mat-dialog-actions> -->

<!-- <mat-dialog-content *ngIf="isPdfDocument" [innerHTML]="message" id="pdfDocument">
</mat-dialog-content> -->
<!-- <mat-dialog-actions align="center" *ngIf="html">
    <button mat-raised-button class="btn cancelar" (click)="onConfirmClick()" tabindex="-1">Cancelar</button>
    <button *ngIf="showButtonAccept" class="btn guardar" (click)="printDocument()">Guardar</button>
</mat-dialog-actions> -->